"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import BackgroundVideo from "../components/BackgroundVideo";
import ParticlesBackground from "../components/ParticlesBackground";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: [0.6, -0.05, 0.01, 0.99] },
};

const staggerContainer = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

export default function HomePage() {
  return (
    <>
      <BackgroundVideo />
      <ParticlesBackground />

      <main className="relative z-10 min-h-[90vh] flex items-center justify-center px-6 pt-40 pb-24">
        <motion.div
          className="text-center max-w-5xl mx-auto"
          initial="initial"
          animate="animate"
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp} className="relative inline-block mb-10">
            <motion.img
              src="/phytoncoin_logo.png"
              alt="PhytonCoin Logo"
              width={140}
              height={140}
              className="mx-auto translate-y-2 sm:translate-y-4"
              whileHover={{
                scale: 1.1,
                filter: "drop-shadow(0 0 20px rgba(30, 166, 122, 0.6))",
              }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          <motion.h1
            variants={fadeInUp}
            className="font-grotesk text-4xl md:text-6xl lg:text-7xl font-bold leading-tight text-white mb-6"
          >
            PhytonCoin rewards verified{" "}
            <span
              className="relative inline-block"
              style={{
                background: "linear-gradient(135deg, #1ea67a 0%, #00ffa2 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              action,
            </span>{" "}
            not ownership, hardware, or capital.
          </motion.h1>

          <motion.p
            variants={fadeInUp}
            className="text-xl md:text-2xl text-primary mb-12"
            style={{ textShadow: "0 0 20px rgba(30, 166, 122, 0.4)" }}
          >
            A new kind of blockchain. Open to everyone.
          </motion.p>

          <motion.div
            variants={fadeInUp}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                href="/manifesto"
                className="btn-ghost px-8 py-4 text-lg font-semibold"
              >
                Read the Manifesto
              </Link>
            </motion.div>

            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Link
                href="/technology"
                className="btn-ghost px-8 py-4 text-lg font-semibold"
              >
                How It Works
              </Link>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 1 }}
            className="mt-16 text-white/60 text-sm"
          >
            Scroll to explore
          </motion.div>
        </motion.div>
      </main>
    </>
  );
}
